import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { UserDataService } from './user-data.service';

@Injectable()
export class LoginGuardService implements CanActivate {

  constructor(
    private userDataService: UserDataService,
    private router: Router,
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.userDataService.checkUser().pipe(
      map(user => {
        if (user === null) {
          this.router.navigate(['/login']);
          return false;
        } else if (!!(user?.emailActivationTermDate)) {
          this.router.navigate(['/feedback']);
          return false;
        }
        return true;
      }),
      catchError((error, caught) => {
        return of(false);
      })
    );
  }
}
